module.exports = __webpack_public_path__ + "static/img/edit.e7faebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/edit.png
// module id = KzIr
// module chunks = 1